<template>
	<div class="message" :class="classes">
        <p class="message__title">{{ message.title }}</p>
        <p class="message__content">{{ message.message }}</p>
    </div>
</template>

<script>
export default {
  name: 'message',
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  computed: {
    classes() {
      return [
        { 'message--info': this.message.type === 3 },
        { 'message--success': this.message.type === 4 },
        { 'message--warning': this.message.type === 2 },
        { 'message--error': this.message.type === 1 }
      ]
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Message.vue?7ccf08aa